import React, { useMemo } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { ReactRenderer } from '@atlaskit/renderer';
import { encodeAdf } from '@atlassian/conversation-assistant-content-transformer/adf-encoder';

import type { MarkdownElementType } from '../types';

export const MarkdownElement = ({
	component,
}: {
	component: MarkdownElementType;
}): React.JSX.Element | null => {
	const markdown = component.children?.[0] as string;

	const docContent = useMemo(() => (markdown ? encodeAdf(markdown, false) : undefined), [markdown]);
	return docContent ? (
		<Box testId="dynamic-layout-markdown">
			<ReactRenderer document={docContent} />
		</Box>
	) : null;
};
